/// <reference path="../../../../../../shared/utils/View.ts"/>

import { CooperationService } from "../../../../../../shared/services/CooperationService";
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { AppValidationService } from '../../services/AppValidationService';
import { AppApiService } from "../../services/AppApiService";
import { BasicApplicationService } from '../../../../../../shared/services/BasicApplicationService';
import { BasicErrorService } from '../../../../../../shared/services/BasicErrorService';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { User } from "../../../../../../shared/models/api/User/User";
import { AppRateService } from "../../services/AppRateService";
import { CheckPageController } from "./CheckPageController";
import { ApplicationPages } from "../../Constants";
import { AppFormModel } from "../../models/AppFormModel";
import { AppModelAdapter } from "../../helper/AppModelAdapter";
import { AppApplicationModel } from "../../models/AppApplicationModel";
import { EcommerceProductStatus } from '../../../../../../shared/enums/EcommerceProductStatus';
import { AppUtils } from '../../../../../../shared/utils/index';

export class InputPageController implements StepController, InputPageViewEvents {
	private appValidationService: AppValidationService;
	private readonly parent: AppController;
	private readonly options: MglAddMembersAppOptions;
	private readonly loader: BasicLoader<MglAddMembersAppDefinition>;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appViewService: AppViewService;
	private readonly applicationRouter: BasicApplicationRouter<MglAddMembersAppDefinition>;
	private readonly applicationService: BasicApplicationService<MglAddMembersAppDefinition>;
	private readonly errorService: BasicErrorService<MglAddMembersAppDefinition>;
	private readonly appApiService: AppApiService;
	private readonly cooperationService: CooperationService<MglAddMembersAppDefinition>;
	private readonly user: User;
	private readonly $ctx: JQuery;
	private readonly appRateService: AppRateService;
	private readonly priorityUserVisible = "user-visible";

	constructor(parent: AppController, options: MglAddMembersAppOptions, loader: BasicLoader<MglAddMembersAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.user = user;

		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(options, loader);
		this.applicationRouter = new BasicApplicationRouter(options);
		this.applicationService = new BasicApplicationService(options);
		this.errorService = new BasicErrorService(options);
		this.appRateService = new AppRateService(this.options, this.user);
		this.appApiService = new AppApiService(options);
		if (this.options.app.iscooperation) {
			this.cooperationService = new CooperationService(options);
		}
		this.updateValidationRules();
		this.$ctx = options.$ctx;
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			this.applicationRouter.back();
		}
	}

	/**
	 * User must be available and a member (if it is an plusupgrade the user has to be non-plus).
	 */
	private checkPreconditions(): boolean {
		const partnerAdvertisementData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
		if (this.options.app.ispremiumupgrade) {
			return this.user.ValidMember && !this.user.PremiumMember;
		} else if (this.options.app.isplusupgrade) {
			return !this.user.PlusMember && this.user.ValidMember;
		} else if (this.options.app.ispartneradvertisement) {
			return undefined !== partnerAdvertisementData.productActiveOrderNumber && this.user.ValidMember;
		}
		return this.user.ValidMember;
	}

	private updateValidationRules(): void {
		if (!this.options.app.isplusupgrade && !this.options.app.ispremiumupgrade) {
			this.options.app.validatorRules.rules.AddFamilyMembers = { addfamilymembers: true };
		}
	}

	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): object {
		const appModel = this.appPersistenceService.getApplicationModel();

		let hasJuv = false;
		let hasChild = false;
		if (appModel.FormModel.Kinder) {
			appModel.FormModel.Kinder.forEach(child => {
				if (child.IsJuv && !hasJuv) {
					hasJuv = true;
				} else if (!child.IsJuv && !hasChild) {
					hasChild = true;
				}
			});
		}

		return {
			IsCooperation: this.options.app.iscooperation !== undefined ? this.options.app.iscooperation : false,
			FormModel: appModel.FormModel,
			PartnerModel: appModel.FormModel.Partner,
			User: this.user,
			UserData: this.user.UserData,
			Tarif: appModel.ContractInfoModel,
			IsPlusUpgrade: this.options.app.isplusupgrade,
			IsPremiumUpgrade: this.options.app.ispremiumupgrade,
			IsPartneradvertising: this.options.app.ispartneradvertisement,
			HidePartnerHeadline: true,
			HasJuv: hasJuv,
			HasChild: hasChild
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.parent.afterRenderApp();

			if (this.options.app.iscooperation) {
				this.cooperationService.initCooperationViewService();
				this.options.app.validatorRules = this.cooperationService.mergeValidatorRules(this.options.app.validatorRules);
				const cooperationModel = this.cooperationService.getModelFromStore();
				this.cooperationService.setModelToView(cooperationModel);
			}
			this.appValidationService = new AppValidationService({ options: this.options }, $(this.$ctx).find(`#${this.options.app.applicationId} form`), this.user);
			this.appPersistenceService.setApplicationStepToStore(this.options.app.currenttemplate.step);
			this.checkPartnerAdvertisement();
			const formModel = this.appPersistenceService.getFormModelFromStore();

			this.appViewService.updateDiscountDebendentContent(this.user.UserData.Mitgliedschaft.InAusbildung || this.user.UserData.Mitgliedschaft.Schwerbehindert);

			this.appViewService.addInputPageListeners(this);
			this.CheckUrlHasValidSalesmannNumber(formModel);
			this.CheckUrlHasValidAdvertisingKey(formModel);
			if (formModel.Bonus.Bonuscode) {
				this.appValidationService.validateBonuscode(formModel.Bonus.Bonuscode, () => {
					this.appViewService.enableBonusEmailField();
				}, this.handleCheckBonuscodeError.bind(this)
					, this.handleCheckBonuscodeError.bind(this));
			}

			this.appRateService.updateRate();
		});
	}

	private onAdvertisingDeny(jqxhr: JQueryXHR): void {
		if (jqxhr.responseJSON && !jqxhr.responseJSON.Data && jqxhr.responseJSON.Messages.length > 0) {
			this.appViewService.showErrorDialog(this.appValidationService.getMappedBackendMessage(jqxhr.responseJSON.Messages[0].Id), this.onAdvertisingDenyClose.bind(this));
		}
	}

	public onAdvertisingDenyClose(): void {
		this.applicationRouter.routeToLocation(this.options.app.partneradvertisingnotallowedurl);
	}

	private checkPartnerAdvertisement(): void {
		if (this.options.app.ispartneradvertisement) {
			const formModel = this.appPersistenceService.getFormModelFromStore();
			this.appPersistenceService.setFormModelToStore(formModel);

			if (this.user.UserData.Mitgliedschaft.HatPartner) {
				this.errorService.showModal(this.$ctx.find('#error_dialog_haspartner'));
			} else if (!this.user.hasChangePermissions()) {
				this.errorService.showModal(this.$ctx.find('#error_dialog_nopermission'));
			} else {
				this.appApiService.checkAdvertisingAllowed(this.onAdvertisingDeny.bind(this));
			}
		}
	}

	public salesmanNoBlurListener(ev: Event): void {
		const formModel = new AppFormModel();
		const field = ev.target as HTMLInputElement;
		formModel.Profiwerbernummer = field.value;
		this.appValidationService.validateSalesmenNo(formModel,
			() => {
				// success: nothing to do
			}, () => {
				// failure: handled by appValidationService
			}, true, field);
	}

	/**
	 * apply changes if user changes form elements on the page
	 */
	public onViewChanged(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appPersistenceService.getFormModelFromStore();
			formModel.Partner = this.appViewService.getPartnerDataModel();
			formModel.Kinder = this.appViewService.getChildDataModel();
			this.appViewService.updateBonusValues(formModel);
			this.appViewService.updateSalesmanFields(formModel);
			this.appViewService.updateOfficeAdvertisingKey(formModel);
			this.appPersistenceService.setFormModelToStore(formModel);
			if (this.options.app.iscooperation) {
				this.cooperationService.setModelToStore(0);
			}
		}, this.priorityUserVisible);
	}

	public onFamilyMemberAdded(): void {
		AppUtils.Helper.scheduleTask(() => {
			this.appValidationService.updateValidationMessages();
		}, this.priorityUserVisible);
	}

	public rerenderChildren(): void {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		if (formModel.Kinder) {
			let isFirstChild = true;
			let isFirstJuv = true;
			for (const child of formModel.Kinder) {
				if (child.IsJuv && isFirstJuv) {
					isFirstJuv = false;
					continue;
				}
				if (!child.IsJuv && isFirstChild) {
					isFirstChild = false;
					continue;
				}
				if (child.IsJuv) {
					S.Utils.Clone.cloneBlock(document.querySelectorAll('.js-add-juv')[0]);
				} else {
					S.Utils.Clone.cloneBlock(document.querySelectorAll('.js-add-child')[0]);
				}
			}
			let juvCount = 0;
			let childCount = 0;
			for (const child of formModel.Kinder) {
				if (child.IsJuv) {
					this.appViewService.setChildDataToViewV2(child, `adultchild_${juvCount}`);
					juvCount++;
				} else {
					this.appViewService.setChildDataToViewV2(child, `child_${childCount}`);
					childCount++;
				}
			}
		}
	}

	public onChildBirthdayChanged(ev: Event): void {
		const childId = this.appViewService.getChildIdFromInputChangeEvent(ev);
		const formModel = this.appPersistenceService.getFormModelFromStore();
		formModel.Kinder.forEach(child => {
			if (child.Id === childId) {
				this.appViewService.updateChildSectionInformation(ev.currentTarget as HTMLElement, child);
			}
		});

		this.appPersistenceService.setFormModelToStore(formModel);

		this.rateChangeListener();
	}

	public onFormSubmit(event: JQuery.Event): void {
		event.preventDefault();
		event.stopPropagation();
		const formModel = this.appPersistenceService.getFormModelFromStore();

		if (this.appValidationService.isValid()) {
			if (this.options.app.iscooperation) {
				this.cooperationService.setModelToStore(0);
			}
			AppUtils.View.startLoader();

			if (formModel.Bonus.Bonuscode) {
				this.appValidationService.validateBonuscode(formModel.Bonus.Bonuscode, this.handleCheckBonuscodeSuccess.bind(this), this.handleCheckBonuscodeError.bind(this));
			} else {
				this.handleCheckBonuscodeSuccess();
			}

		} else {
			if (formModel.Bonus) {
				this.appViewService.replaceKooperationstoken();
			}
		}
	}

	private handleCheckBonuscodeSuccess(): void {
		this.appViewService.enableBonusEmailField();
		const appModel = this.appPersistenceService.getApplicationModel();
		if (this.options.app.isofficeadvertisingkey && appModel.FormModel.Werbeschluessel === undefined && this.appValidationService.validatorOfficeAdvertisingKeySecondTry(appModel.FormModel.OfficeWerbeschluessel, this.options.$ctx.find('#officeadvertisingkey'))) {
			this.appValidationService.validateOfficeAdvertisingKey(appModel.FormModel.OfficeWerbeschluessel.toString(),
				this.handleOfficeAdvertisingKeySuccess.bind(this), this.handleOfficeAdvertisingKeyError.bind(this));
		}
		else {
			this.handleOfficeAdvertisingKeySuccess(false);
		}
	}

	private handleOfficeAdvertisingKeySuccess(isValid: boolean): void {
		const appModel = this.appPersistenceService.getApplicationModel();
		this.pushEcommerceBasisPacket(appModel);
		const advertisingData = this.appPersistenceService.getPartnerAdvertisingDataFromStorage();
		if (isValid && appModel.FormModel.OfficeWerbeschluessel && this.options.app.isofficeadvertisingkey) {
			appModel.FormModel.Werbeschluessel = appModel.FormModel.OfficeWerbeschluessel;
			this.appPersistenceService.setApplicationModel(appModel);
		}
		const requestModel = AppModelAdapter.getAnlageApi(appModel.FormModel, this.user, advertisingData, this.options, true);
		AppUtils.View.startLoader();
		this.appApiService.submitEnclosure(requestModel, this.submitSuccess.bind(this), this.submitFailed.bind(this));
	}
	private handleOfficeAdvertisingKeyError(): void {
		AppUtils.View.stopLoader();
	}

	private submitSuccess(): void {
		const pageOptions = this.applicationService.preparePageOptions(ApplicationPages.Check);
		const controller = new CheckPageController(this.parent, pageOptions, this.loader, this.user);
		controller.start();
	}

	private submitFailed(jqxhr: JQueryXHR): void {
		T.Utils.View.stopLoader();
		this.errorService.handleError(jqxhr);
	}

	private handleCheckBonuscodeError(): void {
		this.appViewService.replaceKooperationstoken();
		AppUtils.View.stopLoader();
	}

	public validateBonuscode(ev: Event): void {
		this.appValidationService.validateBonuscode(undefined, () => {
			this.appViewService.enableBonusEmailField();
		}, () => {
			this.appViewService.replaceKooperationstoken();
		}, ev.target as HTMLInputElement);
	}

	public rateChangeListener(): void {
		AppUtils.Helper.scheduleTask(() => {
			this.appRateService.updateRate();
		}, this.priorityUserVisible);
	}

	private CheckUrlHasValidSalesmannNumber(formModel: AppFormModel): void {
		const salesmannumberfromurl = this.options.app.salesmannumberfromurl;
		if (salesmannumberfromurl && salesmannumberfromurl.length > 0) {
			const formModelTemp = formModel;
			formModelTemp.Profiwerbernummer = salesmannumberfromurl;
			this.appViewService.hideSalesmanFiels();
			this.appApiService.checkSalesmanNumbers(AppModelAdapter.getProfiwerberApi(formModelTemp, this.options.app.advertisingkey),
				() => {
					AppUtils.Helper.scheduleTask(() => {
						formModel.Profiwerbernummer = salesmannumberfromurl;
						formModel.Pruefziffer = 0;
						this.appPersistenceService.setFormModelToStore(formModel);
					}, 'background');

				}, () => {
					formModel.Profiwerbernummer = "";
				});
		}
	}

	private CheckUrlHasValidAdvertisingKey(formModel: AppFormModel): void {
		const gsWbs = T.Utils.Helper.getUrlParameter('gswbs');
		if (gsWbs && gsWbs.length > 0) {
			this.appApiService.checkMglWbs(gsWbs,
				() => {
					formModel.Werbeschluessel = gsWbs;
					this.appPersistenceService.setFormModelToStore(formModel);
				}, () => {
					formModel.Werbeschluessel = Number(this.options.app.advertisingkey);
					this.appPersistenceService.setFormModelToStore(formModel);
				});
		}
		else {
			formModel.Werbeschluessel = undefined;
			this.appPersistenceService.setFormModelToStore(formModel);
		}
	}

	private async pushEcommerceBasisPacket(appModel: AppApplicationModel): Promise<void> {
		let model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model = AppModelAdapter.updateEcommerceModel(model, appModel, this.options);

		model.productStatus = EcommerceProductStatus.CHECKOUT;
		model.checkOutStep = "1";

		await T.Utils.Tracking.setEcommerceModel(model);
		T.Utils.Tracking.push(model, T.Utils.Tracking.CHECKOUT);
	}
}
